import type {BaseEntity} from "~/types/entity";
import type {IAlgorithmData, IVariable} from "~/types/algorithm-editor/algorithm-types";
import type {ExecTime} from "~/types/loyalty/loyalty_rule";

export interface ISalesChannel extends BaseEntity{
}

export interface IPromoCode extends BaseEntity{
    start_date?: string|undefined,
    finish_date?: string|undefined,
    allow_multiple_use: boolean,
}

export interface IBadge extends BaseEntity{
    text: string
    description: string
    style: string
}

export interface IRulePriority extends BaseEntity {
    channels: any[]
}

export interface IMarketingRule extends BaseEntity {
    active_since: string|undefined
    active_till: string|undefined
    stop_discount: boolean|undefined
    stop_rules: boolean|undefined
    rule_priority_id: number|undefined
    conditions: any[]
    event_types: string[]
    channels: number[]
    stocks: number[]
    marketing_politic_id: number | undefined
    marketing_condition_id: number | undefined
}

export interface IMarketingAlgorithmData extends IAlgorithmData{
    id?: number
    result: IVariable[]
}

export interface IMarketingPolitic extends BaseEntity{
    algorithm: IMarketingAlgorithmData|undefined
    events: string[]
}

export interface IMarketingCondition extends BaseEntity{
    algorithm: IAlgorithmData|undefined
    events: string[]
}

export interface ICommercialPriority extends BaseEntity{
}

export interface ICommercialRule extends BaseEntity{
    start?: string|undefined
    finish?: string|undefined
    commercial_priority_id?: number|undefined
    filters: ICommercialRuleFilterItem[]
}

export interface ICommercialRuleFilterItemParam {
    param_id: number|undefined
    value: string
}

export interface ICommercialRuleFilterItem {
    condition?: string
    object?: number
    value?: string|number|undefined|ICommercialRuleFilterItemParam
}

export type MarketingTriggerData = IMarketingRunType | IMarketingTriggerSchedule
export interface IMarketingTrigger extends BaseEntity {
    type: number
    marketing_politic_id: number | undefined
    politic_schedule: ExecTime
    data: MarketingTriggerData | undefined
    mapping: IMarketingMaping[] | undefined
}

export interface IMarketingRunType {
    run_type: number
    event_type_code: string
}

export interface IMarketingTriggerSchedule {
    schedule: string
}

export interface IMarketingMaping {
    code: string
    value_type: number
    value: string
    title: string
    required: boolean
    type: string
    items: IMarketingMaping[]|undefined
}

export const OBJECT_TYPE = 'object'
export const ARRAY_TYPE = 'array'

export interface IMarketingParameterHistory {
    date: string
    parameter_name: string
    old_value: string
    new_value: string
    object: string
    data: string
}
